import { cn } from "@local/utils/src/cn"
import { getCdnUrl } from "@local/utils/src/getCdnUrl"
import type { CSSProperties, ReactNode } from "react"

interface Props {
  children: ReactNode
  className?: string
  touchEdges?: boolean
  fullWidthBgColor?: string
  fullWidthBgImageUrl?: string
  id?: string
  style?: CSSProperties
  role?: string
  contentClassName?: string
}

export const ContentBlockServer = ({
  id,
  children,
  className,
  touchEdges,
  fullWidthBgColor,
  style,
  fullWidthBgImageUrl,
  role,
  contentClassName,
}: Props) => {
  return (
    <div
      className={cn(
        "content-block w-full",
        fullWidthBgColor ? fullWidthBgColor : "",
        className
      )}
      id={id}
      style={
        fullWidthBgImageUrl
          ? {
              ...style,
              backgroundImage: `url(${getCdnUrl({ src: fullWidthBgImageUrl })})`,
            }
          : style
      }
      role={role}
    >
      <div
        className={cn(
          touchEdges ? "w-full" : "mx-auto max-w-7xl",
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  )
}
